<div class="bg-[#f7f6fb] w-[100%]">
  <div
    class="flex h-[122px] flex-col items-center justify-center p-6 border-2 border-dashed border-gray-300 cursor-pointer transition-all duration-300 bg-[#F7F6FB] hover:bg-gray-100"
  >
    <button
      type="button"
      class="bg-[#D9D9D9] text-[#343A40] px-4 py-2 rounded focus:outline-none"
      (click)="fileControlRef.click()"
    >
      Attach File
    </button>
    <p class="text-[14px] pt-[5px] !font-medium !m-0 !text-[#21252A]">
      Drag & Drop
    </p>

    <input
      type="file"
      multiple
      #fileControlRef
      (change)="onFileUpload($event)"
      hidden
    />
  </div>
</div>
